<template>
  <div class="rkcz">
    <div class="rkcz">
      <div>分地区的常住人口和外来人口</div>
      <div class="two">
        <div class="one">
          <span>{{datas.czrk}}</span><span>(人)</span>
          <div>常住人口</div>
        </div>
        <div class="one">
          <span>{{ datas.czwlrk }}</span><span>(人)</span>
          <div>外来人口</div>
        </div>
      </div>
      <div class="npm">
        <p style="margin: 5vh">分地区的常住人口和外来人口</p>
        <div
          ref="echartsINof"
          class="echarts"
          style="height: 40vh; width: 30vw"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { tj,czrk } from "@/network";
export default {
  data() {
    return {
      rows: {},
      datas: [],
      name: "常住人口",
    };
  },
  created() {},
  mounted() {
    // this.getInfoList();
    this.getInfoDatas();
    this.getname();
    this.getInfoData();
    
    // this.handEchart();
  },
  methods: {
    getname() {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      myechart.on("legendselectchanged", (params) => {
        this.name = params.name;
        this.getInfoData();
      });
    },
    async getInfoDatas() {
      const { code, rows, total } = await czrk({villagesCode: "110105011"});
      this.datas = rows[0];
    },
    async getInfoData() {
      const { code, data, msg } = await tj({
        tableName: "jxq_czrk",
        streetCode: "110105011",
      });
      //大小排序开始
      // var compare = function (attribute) {
      //   return function (obj1, obj2) {
      //     var val1 = obj1[attribute];
      //     var val2 = obj2[attribute];
      //     if (val1 < val2) {
      //       return 1;
      //     } else if (val1 > val2) {
      //       return -1;
      //     } else {
      //       return 0;
      //     }
      //   };
      // };
      // if (this.name == "常住人口") {
      //   let datas = data.sort(compare("czrk")); //通过Id排序完成后的数组
      // } else {
      //   let datas = data.sort(compare("czwlrk")); //通过Id排序完成后的数组
      // }
      //大小排序结束
      let czrk = []; //常住人口
      let villages_name = []; //社区名称
      let czwlrk = []; //常住外来人口
      for (const item of data) {
        czrk.push(item.czrk);
        villages_name.push(item.villages_name);
        czwlrk.push(item.czwlrk);
      }
      this.handEchart(czrk, villages_name, czwlrk);
    },
    // async getInfoList() {
    //   const { code, rows, total } = await czrk();
    //   this.rows = rows[0];
    // },
    handEchart(e, es, ese) {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        // color: "#FF6900",
        // tooltip: {
        //   formatter: "{b} : {c} 人",
        // },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          //sort等于1或0
          selectedMode: "single", //取消图例的点击事件,让每次只选择一个图例变成都显示
          // selectedMode: "multiple", //取消图例的点击事件
          // selectedMode: false, //取消图例的点击事件
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },

        yAxis: {
          type: "category",
          data: es,
          textStyle: {
            color: "#fff",
          },
        },
        // styleColor:"#fff",
        textStyle: {
          color: "#fff",
        },
        series: [
          {
            name: "常住人口",
            color: "#00BFFF",
            type: "bar",
            data: e,
          },
          {
            name: "常住外来人口",
            color: "	#7CFC00",
            type: "bar",
            data: ese,
          },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
.rkcz {
  div {
    color: #fff;
    text-align: center;
    margin-top: 2vh;
    font-size: 18px;
    margin-bottom: 2vh;
  }
  .two {
    border: 1px solid #21517d;
    margin: 0 2vw;
    margin-bottom: 0.8vw;
    .one {
      width: 12vw;
      display: inline-block;
      font-size: 18px;
      color: #fffd7d;
      padding-top: 1vh;
      span:nth-child(2) {
        font-size: 12px;
      }
      div {
        font-size: 12px;
        color: #fff;
        margin-top: 5px;
      }
    }
  }
}
</style>
